module.exports = __webpack_public_path__ + "img/logo-white.fd32f787.png";